const useStyles = {
  subtitle: {
    marginTop: 1,
  },
}

export default useStyles
